<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <el-button class="inline" v-loading="isLoadingExport" v-if="getRapport.total > 0">
        <downloadexcel
            :data="exporter"
            type="xls"
            :name="nomFichierExport">
          {{ $t("posts.report.exportResults") }}
        </downloadexcel>
      </el-button>
    </template>
<!--    Stats -->
    <ubi-panel :title="$t('posts.report.globalTitle')" size="sm">
      <el-row>
        <el-col :lg="16" :md="12">
          <strong>{{ $t("posts.report.lastIntegration") }}</strong>
          <p>{{getEndDate !== null ? convertDate(getEndDate):  ''}}</p>
          <el-row>
            <el-col :lg="12" class="mb-3">
              <ubi-stat-value
                  icon="announcement"
                  :value="getBilanAnnoncesIntegrees"
                  :sub-value="getBilanAnnoncesTraitees"
                  :label="$t('posts.report.adsIntegrated')"
              />
            </el-col>
            <el-col :lg="12" class="mb-3">
              <ubi-stat-value icon="trash" :value="getBilanAnnoncesSupprimes" :label="$t('posts.report.adsDeleted')" />
            </el-col>
          </el-row>
        </el-col>
        <el-col :lg="8" :md="12">
          <div class="text-muted" style="text-align: center;">
            <el-image
                :src="sitimmoUser.logoUrl"
                :srcset="sitimmoUser.logoUrl"
                v-if="sitimmoUser.logoUrl != null"
            />
            <p v-if="sitimmoUser.nom != null">{{sitimmoUser.nom}}</p>
          </div>
        </el-col>
      </el-row>
    </ubi-panel>

<!-- Filters-->
    <el-form @submit.prevent.native="doFilter">
      <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container @resetfilter="resetAllfilters">
          <el-row :gutter="25">
            <el-col :lg="10">
              <!-- Search field -->
              <el-form-item :label="$t('planning.searchByTitle')">
                <el-input
                    v-model="localFilters.search"
                    :placeholder="$t('planning.searchPlaceholder')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item style="margin-top: 25px;">
                <el-radio-group v-model="localFilters.typeError">
                  <el-radio label="ERROR,WARN">{{this.$t('general.filters.allAds')}}</el-radio>
                  <el-radio label="WARN">{{this.$t('posts.report.filterWarn')}}</el-radio>
                  <el-radio label="ERROR">{{this.$t('posts.report.filterRejected')}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </ubi-search-container>
      </ubi-panel>
    </el-form>

<!--Tableau -->
    <ubi-panel>
      <PaginationPage  :total="getRapport.total"
                       :currentPage.sync="currentPage"
                       :pageSize.sync="pageSize"
                       @update:currentPage="fetchPage"
                       @update:pageSize="fetchPageSize"
      />
      <el-button type="mini" slot="actions" v-loading="isLoadingExport" v-if="getRapport.total > 0">
        <downloadexcel
            :data="exporter"
            type="xls"
            :name="nomFichierExport">
          {{ $t("posts.report.exportResults") }}
        </downloadexcel>
      </el-button>
      <el-table :data="currentAnnonces" v-loading="isLoadingRapport">
        <el-table-column type="expand" >
          <template v-slot="{ row: post }" >
            <p class="mb-0" v-for="rapport in post.messages" :key="rapport.idUniq">
              <ubi-icon name="alert" class="text-warning ml-2" v-if="rapport.codeInterne === 'WARN'" />
              <ubi-icon
                  name="close"
                  class="text-white bg-danger rounded-circle ml-2"
                  v-if="rapport.codeInterne === 'ERROR'"
              />
              <em class="ml-2">{{ rapport.message}}</em>
            </p>
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template v-slot="{ row: post }">
            <img width="80"
                 alt=""
                 :src="post.photoPrincipale.url_miniature"
                 :srcset="post.photoPrincipale.url_miniature"
                 v-if="post.photoPrincipale"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('posts.report.columnAd')">
          <template v-slot="{ row: post }">
            <router-link v-if="post.id && !isSubUser" :class="{ 'text-muted': post.status === 'ignored' }" :to="{ name: 'post-view', params: { post: post.id } }">{{post.reference}} - {{post.titre}}</router-link>
            <div v-else>{{post.reference}}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('posts.report.columnDateCreation')">
          <template v-slot="{ row: post }">
            <div v-if="post.dateCreation">{{post.dateCreation}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('posts.report.columnDateModification')">
          <template v-slot="{ row: post }">
            <div v-if="post.dateModification">{{post.dateModification}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('posts.report.columnPictures')" width="100">
          <template v-slot="{ row: post }">
            <div v-if="post.photos">{{post.photos.length}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center">
          <template #header>
            <el-tooltip effect="dark" :content="$t('posts.report.numberCountWARN')" placement="top-start">
              <ubi-icon name="alert" class="text-warning ml-2" />
            </el-tooltip>
          </template>
          <template #default="{ row: post}">
            {{countWarningMessages(post.messages)}}
          </template>
        </el-table-column>
        <el-table-column width="50" align="center">
          <template #header>
            <el-tooltip effect="dark" :content="$t('posts.report.numberCountERROR')" placement="top-start">
              <ubi-icon
                  name="close"
                  class="text-white bg-danger rounded-circle ml-2"
              />
            </el-tooltip>
          </template>
          <template #default="{ row: post}">
            {{countErrorMessages(post.messages)}}
          </template>
        </el-table-column>
      </el-table>
      <PaginationPage  :total="getRapport.total"
                       :currentPage.sync="currentPage"
                       :pageSize.sync="pageSize"
                       @update:currentPage="fetchPage"
                       @update:pageSize="fetchPageSize"
      />
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '@/components/Panel.vue'
import UbiSearchContainer from '@/components/SearchContainer.vue'
import downloadexcel from 'vue-json-excel'
import { convertDate } from '@/helpers/functions/convertDate'
import UbiStatValue from '@/components/statistics/StatValue.vue'
import UbiIcon from '@/components/Icon.vue'
import PaginationPage from '@/components/ui/PaginationPage.vue'

export default {
  name: 'GlobalIntegrationReport',
  components: { PaginationPage, UbiIcon, UbiStatValue, downloadexcel, UbiSearchContainer, UbiPanel },
  data () {
    return {
      nomFichierExport: this.$t('posts.report.filenameExportIntegration') + '.xls',
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    isSubUser () {
      return this.$store.getters.isSubUser
    },
    getRapport () {
      return this.$store.getters['globalIntegrationReport/getRapport']
    },
    currentAnnonces () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (Array.isArray(this.getRapport.annonces)) {
        return this.getRapport.annonces.slice(start, end)
      }
      return []
    },
    getEndDate () {
      return this.$store.getters['globalIntegrationReport/getEndDate']
    },
    getBilanAnnoncesIntegrees () {
      return this.$store.getters['globalIntegrationReport/getBilanAnnoncesIntegrees']
    },
    getBilanAnnoncesTraitees () {
      return this.$store.getters['globalIntegrationReport/getBilanAnnoncesTraitees']
    },
    getBilanAnnoncesSupprimes () {
      return this.$store.getters['globalIntegrationReport/getBilanAnnoncesSupprimes']
    },
    localFilters () {
      return this.$store.getters['globalIntegrationReport/getFilters']
    },
    isLoadingRapport () {
      return this.$store.getters['globalIntegrationReport/getLoadingLogs']
    },
    isLoadingExport () {
      return this.$store.getters['globalIntegrationReport/getLoadingExport']
    },
    exporter () {
      return this.$store.getters['globalIntegrationReport/getMessages']
    }
  },
  methods: {
    convertDate,
    doFilter () {
      this.$store.dispatch('globalIntegrationReport/loadRapportGlobalIntegrationwithFilters')
    },
    resetAllfilters () {
      this.$store.commit('globalIntegrationReport/setResetFilters')
      this.$store.dispatch('globalIntegrationReport/loadRapportGlobalIntegration')
    },
    countWarningMessages (messages) {
      let countByCode = 0
      for (const item of messages) {
        if (item.codeInterne === 'WARN') {
          const { codeInterne } = item
          if (countByCode[codeInterne]) {
            countByCode++
          } else {
            countByCode = 1
          }
        }
      }
      return countByCode
    },
    countErrorMessages (messages) {
      let countByCode = 0
      for (const item of messages) {
        if (item.codeInterne === 'ERROR') {
          const { codeInterne } = item
          if (countByCode[codeInterne]) {
            countByCode++
          } else {
            countByCode = 1
          }
        }
      }
      return countByCode
    },
    fetchPage (page) {
      this.currentPage = page
    },
    fetchPageSize (size) {
      this.pageSize = size
      this.currentPage = 1
    }
  },
  beforeMount () {
    this.$store.dispatch('globalIntegrationReport/loadRapportGlobalIntegration')
    this.$store.dispatch('globalIntegrationReport/loadExportIntegration')
  }
}
</script>
